import React from 'react';
import { reduxForm } from 'redux-form';
import Field from 'src/ConnectedComponents/fields/Field';
import { Link } from 'react-router-dom';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { requestRefreshConfirmationCode } from 'src/redux/authUsers/authUser.action';

import Logo from 'src/ConnectedComponents/utils/Logo';
import LeftArrow from 'src/assets/left_arrow.svg';
import styles from './index.css';
import { Span } from 'src/lib/StyledComponents';

class ForgotPassword extends React.Component {
	state = { submittedForm: false };

	submitEmail = ({ email }) => {
		this.props.requestRefreshConfirmationCode({ email: email }, true);
		this.setState({ submittedForm: true });
	};

	render() {
		const { handleSubmit, error } = this.props;

		return (
			<form onSubmit={handleSubmit(this.submitEmail)} className={styles.ForgotPassword}>
				<Logo />
				<div className={styles.ForgotPasswordPanel}>
					<div className={styles.Title}>
						<Link className={styles.BackLink} to={`login`}>
							<LeftArrow />
						</Link>
						<Span flex="1">Reset your password</Span>
					</div>
					{this.state.submittedForm ? (
						<div className={styles.Text}>
							If an account with this email address exists, we will send you an email
							with further instructions.
						</div>
					) : (
						<React.Fragment>
							{error && <div className={styles.Error}>{error}</div>}
							<Field
								name="email"
								placeholder="Email"
								component="input"
								className={styles.Input}
								isRequired={true}
							/>
							<div className={styles.ButtonContainer}>
								<button type="submit" className={styles.ResetPasswordButton}>
									Email me a reset link
								</button>
							</div>
						</React.Fragment>
					)}
				</div>
			</form>
		);
	}
}

ForgotPassword = reduxForm({ form: 'forgot-password', enableReinitialize: true })(ForgotPassword);

ForgotPassword = withRouter(ForgotPassword);

const mapStateToProps = (_, ownProps) =>
	ownProps && ownProps.location ? { initialValues: ownProps.location.state || {} } : {};

const actions = { requestRefreshConfirmationCode };

ForgotPassword = connect(mapStateToProps, actions)(ForgotPassword);

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/ForgotPassword/index.js